import factory from './icon';
import Svg from './glyphs/search-outline.svg';

export default factory(Svg);
